import React from "react";
import { Container, Row, Form, Button } from "react-bootstrap";

import responsiblesService from "presentation/services/responsibles";
import addressesService from "presentation/services/addresses";
import phonesService from "presentation/services/phones";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import ResponsibleForm from 'presentation/pages/responsibles/elements/form';

import { handleChange, getDocumentFieldType, dateIsInvalid } from "presentation/utils/functions/generic";

import moment from "moment";

class ResponsibleAdd extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      dependentId: null,
      studentId: null,
      actionLoading: false,
      error: false,
      message: '',
      data: [],
      phones: [],
      totalPhoneItems: 1
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    const { location } = this.props;

    const { newRegistration, personName, personId, personEntity, studentId, dependentId, dependentRegistration, dependentName, academicPeriodId } = location.state || {};

    var form = {};

    if (personId && personEntity) {
      var genderId = personEntity.naturalPerson?.gender ? parseInt(personEntity.naturalPerson?.gender) : undefined;

      var documentFieldTypeInfo = personEntity.documentFieldType ? getDocumentFieldType(personEntity.documentFieldType.toString().toLowerCase()) : undefined;
      var documentFieldTypeId = typeof (documentFieldTypeInfo) === 'undefined' ? -1 : documentFieldTypeInfo.id;


      form.birthdate = personEntity.naturalPerson?.birthdate != null ? moment(personEntity.naturalPerson?.birthdate, 'YYYY-MM-DD').format("YYYY-MM-DD") : null;

      form.personId = personId;
      form.naturalPersonId = personEntity.naturalPerson?.id;
      form.userId = personEntity.userId;
      form.name = personEntity.name;
      form.displayName = personEntity.displayName;
      form.genderId = genderId;
      form.documentField = personEntity.documentField;
      form.documentFieldType = documentFieldTypeId;
    } else {
      if (newRegistration && personName) {
        form.name = personName;
        form.displayName = personName;
      }
    }

    form.dependentId = dependentId;
    form.studentName = dependentName;
    form.studentRegistration = dependentRegistration;

    this.setState({ form: form, dependentId: dependentId, studentId: studentId, loading: false });
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  handleSubmit = async () => {
    const { dependentId, studentId, academicPeriodId } = this.props.match.params;

    this.setState({ loading: true, actionLoading: true, error: '' });

    const {
      name,
    } = this.state.form;

    if (!name) {
      this.setState({ loading: false, error: true, message: "Por favor, preencha um nome..." });
    } else {
      let postData = this.state.form;

      postData.gender = "" + postData.gender;
      postData.bloodType = "" + postData.bloodType;
      postData.academicPeriodId = parseInt(academicPeriodId);

      let addressData = this.state.addressForm || [];
      let phones = this.state.phones || [];

      let dateFields = ['birthdate', 'registrationDate', 'birthCertificateIssueDate', 'rgIssueDate'];
      dateFields.map((e, i) => {
        let dateValue = postData[e] || "";
        if (dateIsInvalid(dateValue)) {
          postData[e] = null;
        }
      });


      try {
        const response = await responsiblesService.saveAssociated(postData);
        if (response.error == true) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: response.message
          });
        } else {

          if (!response.sameAddressAsStudent) {
            addressData.personId = response.personId;
            const addressResponse = await addressesService.save(addressData);
            if (addressResponse.error == true) {
              //TODO - notify
            }
          }

          if (phones.length > 0) {
            let phonesData = phones.map((e, i) => {
              e.personId = response.personId;
              return e;
            });

            const phonesResponse = await phonesService.batchManagement(phonesData);

            if (phonesResponse.error == true) {
              //TODO - notify
            }
          }

          this.goTo(`/responsaveis/${dependentId}/${studentId}`);
        }
      } catch (err) {
        this.setState({
          loading: false,
          actionLoading: false,
          error: true,
          message: err.message
        });
      }
    }
  };

  render() {
    let { location } = this.props;
    let { loading, error, message, actionLoading, form, dependentId, studentId, addressForm, phones } = this.state;
    let { handleSubmit } = this;


    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <ResponsibleForm
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                dependentId={dependentId}
                studentId={studentId}
                loading={loading}
                form={form}
                addressForm={addressForm}
                phones={phones}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default ResponsibleAdd;
